import React, {useState, useEffect} from 'react'
import {Header, Button, Form, Checkbox, Search, Divider} from 'semantic-ui-react'
import Dialog from '../../dialog'
import useSWR  from 'swr'
import * as Yup from 'yup'
import {GlossaryFetcher, GlossarySave} from '../../../fetch/glossary'
import {
    marginB10,
    marginB30,
    panelBox,
    marginB4,
    allElements,
    selectedElements
} from "../../glossary/sidebar.module.scss"
import classNames from 'classnames'
import {getApiResponseErrorMessage} from '../../error'
import {fieldNames, statusOptions} from "../options"
import {AppFetcher} from "../../../fetch/application"

let object = null;
const AddDataContent = ({ title, open, loading, onSubmit, onClose, id, item }) => {

    const initialState = {
        loading: false,
        name: '',
        dataObject: '',
        sourceDataContentId: '',
        dataElements: [],
        boundaryConditions: [],
        id: null,
        termId: id,
        type : 'endpoint',
        status: '',
        dataBoundaries: null,
        dataBoundariesSearch: null,
        selectedDataBoundaries: null
    }
    const [state, setState] = useState(initialState)

    const loadElements = React.useRef(true);
    const [dataObjects, setDataObjects] = useState(null);
    const [dataElements, setDataElements] = useState(null);
    //const [dataBoundaries, setDataBoundaries] = useState(null);

    ///term-relationship/boundary-dimensions
    const { data : boundaries, errorBoundaries } = useSWR(!loadElements.current ? null : `/term-relationship/boundary-dimensions`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(() => {
        if(boundaries && boundaries.data) { //if item i set Data Boundaries when setting data content details to state
            //setDataBoundaries(boundaries.data)
            setState(state => {
                return {
                    ...state,
                    dataBoundaries: boundaries.data
                }
            })
        }
    } , [boundaries])

    const { data : dataContent, errorDataContent } = useSWR((item && item.id) ? `/data-content/details/${item.id}` : null, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(function() {
        if(dataContent && dataContent.data) {
            setState({
                ...state,
                id: dataContent.data.id,
                dataElements: dataContent.data.dataElements && dataContent.data.dataElements.map(i=>i.id),
                name: dataContent.data.name,
                dataObject: dataContent.data.dataObject && dataContent.data.dataObject.id && !dataContent.data.sourceDataContentId ? dataContent.data.dataObject.id : null,
                sourceDataContentId: dataContent.data.sourceDataContentId,
                status: dataContent.data.status,
                type: dataContent.data.type,
                boundaryConditions: dataContent.data.boundaryConditions && dataContent.data.boundaryConditions.map(i=>i.termRelationshipId)
            })
            //setSelectedDataBoundaries(dataContent.data.boundaryConditions)
            if (state.dataBoundaries !== null && state.dataBoundaries.length > 0 && dataContent.data.boundaryConditions) {
                const _tmpIndex = dataContent.data.boundaryConditions.map(i => i.termRelationshipId);
                let _tmpB = state.dataBoundaries.filter(item => _tmpIndex.indexOf(item.termRelationship.id) < 0);
                //setDataBoundaries(_tmpB);
                setState(state => {
                    return {
                        ...state,
                        dataBoundaries: _tmpB,
                        selectedDataBoundaries: dataContent.data.boundaryConditions
                    }
                })
            }
            else {
                setState(state => {
                    return {
                        ...state,
                        selectedDataBoundaries: dataContent.data.boundaryConditions
                    }
                })
            }
        }
    }, [dataContent, item])

    const { data : objectList, errorObjects } = useSWR(!loadElements.current ? null : `/data-object/list`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(function() {
        if(objectList && objectList.data) {
            let tmp_objects = [];
            objectList.data.map( object => {
                tmp_objects.push({
                    value: object.id,
                    text: object.name
                })
            })
            setDataObjects(tmp_objects);
        }
    }, [objectList])


    const [dataContents, setDataContents] = useState(null);
    const { data : contentList, errorContent } = useSWR(`/endpoint/data-content/list/${id}`, AppFetcher, { errorRetryCount: 2 })
    React.useEffect(function() {
        if(contentList && contentList.data) {
            let tmp_contents = [];
            contentList.data.map( object => {
                tmp_contents.push({
                    value: object.id,
                    text: object.name,
                })
            })
            setDataContents(tmp_contents)
        }
    }, [contentList, item, ])

    const { data : dataObjectElements, mutate, errorObjectElements } = useSWR((!state.dataObject  || state.dataObject === '') && (!dataContent || !dataContent.data || !dataContent.data.dataObject || !dataContent.data.dataObject.id) ? null : `/data-object/data-elements/${state.dataObject ? state.dataObject : dataContent.data.dataObject.id}`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(function() {
        if (dataObjectElements && dataObjectElements.data) {
            let tmp_elements = [];
            dataObjectElements.data.map(object => {
                let tmp_checked = false;
                if (state.dataElements) {
                    state.dataElements.map(i => {
                        if (i === object.id) {
                            tmp_checked = true
                        }
                    })
                }
                tmp_elements.push({
                    value: object.id,
                    text: object.name,
                    checked: tmp_checked
                })
            })

            setDataElements(tmp_elements)
        }
    },[dataObjectElements, state.dataObject, state.sourceDataContentId, item, state.dataElements])

    const { data : dataContentDetails, errorContentDetails } = useSWR(!state.sourceDataContentId ? null : `/endpoint/data-content/details/${state.sourceDataContentId}`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(function() {
        if(dataContentDetails && dataContentDetails.data) {
            let tmp_content = [];
            if(dataContentDetails.data.dataObject) object = dataContentDetails.data.dataObject.id
            dataContentDetails.data.dataElements && dataContentDetails.data.dataElements.map( object => {
                tmp_content.push({
                    value: object.id,
                    text: object.name,
                })
            })
            setDataElements(tmp_content)
        }
    },[dataContentDetails, item, state.sourceDataContentId])

    const [errors, setError] = useState({})

    const formSchema = Yup.object().shape({
        name: Yup.string()
            .max(255, 'Must be max 255 characters')
            .required(),
        dataObject: Yup.string()
            .required(),
        status: Yup.string()
            .required(),
    });

    const handleInputChange = (e, {name, value}) => {
        if(name === "dataObject"){
            setDataElements(null);
            mutate(`/data-object/data-elements/${value}`);
        }
        if(name === "sourceDataContentId"){
            setDataElements(null);
            mutate(`/data-content/details/${value}`);
        }

        if (errors[name] === true) {
            setError( errors => {
                return {
                    ...errors,
                    [name]: false
                }
            })
        }

        setState( state => {
            return {
                ...state,
                [name]: value
            }
        })

    }

    const [value, setValue] = useState("");
    //const [dataBoundariesSearch, setDataBoundariesSearch] = useState(null);
    //const [selectedDataBoundaries, setSelectedDataBoundaries] = useState(null);

    const handleInputSearch = (e, {value}) => {
        setValue(value)
    }
    React.useEffect(function() { //search: changed on value change
        if(!value || value.trim() === " " || value.trim() === "" || value.trim() === null) {
            //dataBoundariesSearch && setDataBoundariesSearch(dataBoundaries);
            setState(state => {
                return {
                    ...state,
                    dataBoundariesSearch: null,
                }
            })
        }
        else {
            let temp_results = state.dataBoundaries && state.dataBoundaries.filter(item => {
                return item.dataElement.name.toLowerCase().includes(value.toLowerCase())
            })
            //setDataBoundariesSearch(temp_results)
            setState(state => {
                return {
                    ...state,
                    dataBoundariesSearch: temp_results
                }
            })
        }
    }, [value])

    const addElement = (e, data) => {
        let _tmpE = dataElements;
        _tmpE.map((i) => {
            if(i.value === data.value) {
                i.checked = data.checked
            }
            return i;
        })
        setDataElements(_tmpE);
        setState(state => {
            return {
                ...state,
                dataElements: _tmpE.map(i=> i.checked ? i.value : null)
            }
        })
        //loadElements.current = true;
    }

    const addDataBoundary = (e) => {
        loadElements.current = false;
        let _tmpO = state.selectedDataBoundaries ? state.selectedDataBoundaries : [];
        _tmpO.push(e)
        //setSelectedDataBoundaries(_tmpO);

        let tmpSearch = state.dataBoundariesSearch

        let _tmp_boundaries = state.dataBoundaries.filter(item => {
            return item.termRelationship.id !== e.termRelationship.id;
        })

        if(state.dataBoundariesSearch) {
            tmpSearch = state.dataBoundariesSearch.filter(item => {
                return item.termRelationship.id !== e.termRelationship.id;
            })
        }

        //setDataBoundaries(_tmp_boundaries)
        setState(state => {
            return {
                ...state,
                selectedDataBoundaries: _tmpO,
                dataBoundaries: _tmp_boundaries,
                dataBoundariesSearch: tmpSearch
            }
        })
    }

    const removeDataBoundary = (e) => {
        loadElements.current = false;
        const index = state.selectedDataBoundaries.indexOf(e);

        if (index > -1) {
            let _tmp_selected = state.selectedDataBoundaries.filter(item => {
                return item.termRelationship.id !== e.termRelationship.id;
            })
            //setSelectedDataBoundaries(_tmp_selected);
            let _tempO = state.dataBoundaries;
            _tempO.push(e)
            //setDataBoundaries(_tempO);

            let tmpSearch = state.dataBoundariesSearch
            if(state.dataBoundariesSearch) {
                tmpSearch.push(e)
            }
            setState(state => {
                return {
                    ...state,
                    selectedDataBoundaries: _tmp_selected,
                    dataBoundaries: _tempO,
                    dataBoundariesSearch: tmpSearch
                }
            })
        }
    }

    const handleOnSubmit = () => {

        setError({})
        let dataToSave = state;
        if(object) dataToSave.dataObject = object

        formSchema.validate(dataToSave, {abortEarly: false}).then( data => {

            if(state.selectedDataBoundaries && state.selectedDataBoundaries.length > 0) data.boundaryConditions = state.selectedDataBoundaries.map(item => item.termRelationship.id);

            setState( state => {
                return {
                    ...state,
                }
            })


            // Callback
            if (typeof onSubmit === 'function') {
                const reply = GlossarySave(`/endpoint/data-content/save`, data)

                reply.then(res => {
                    if (res.success === true) {
                        setError({})
                        setDataElements(null);
                        //setDataBoundaries(null);
                        setDataContents(null);
                        setState(initialState);
                        onSubmit();
                    }
                }).catch( error => {
                    const errorFields = {}

                    for (const [key, value] of Object.entries(error.response.data.messages)) {
                        errorFields[key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[key]})
                    }

                    setError( err => {
                        return {
                            ...err,
                            ...errorFields
                        }
                    })
                    setState( state => {
                        return {
                            ...state,
                            dialogLoading: false,
                        }
                    })
                })
            }

        }).catch( errors => {

            console.log(errors)

            const errorFields = {}

            if(errors.inner) errors.inner.forEach( error => errorFields[error.path] = error.message.replace(error.path, fieldNames[error.path]))//true)

            setError( err => {
                return {
                    ...err,
                    ...errorFields
                }
            })

        })

    }

    const _onClose = () => {
        setError({})
        setDataElements(null);
        //setDataBoundaries(null);
        setDataContents(null);
        setState(initialState);
        onClose();
    }

    if(loadElements.current === false) {
        loadElements.current = true;
    }

    return (
        <Dialog open={open} onClose={_onClose} closeOnEscape={false} closeOnDimmerClick={false}>

            <Form onSubmit={handleOnSubmit} loading={loading}>

                <Dialog.Header>
                    {state.id !== null ? "Edit" : title} { "Data Content"}
                </Dialog.Header>

                <Dialog.Content>

                    <Form.Group widths="equal">

                        <Form.Field>

                            <Form.Input
                                name="name"
                                error={errors.name}
                                label="Content name"
                                placeholder="Enter content name"
                                value={state.name}
                                onChange={handleInputChange}
                            />
                            <br />

                            <Form.Select
                                name="status"
                                label={"Status"}
                                placeholder="Select Status"
                                options={statusOptions}
                                value={state.status}
                                error={errors.status}
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />

                            <br />
                            {dataObjects && <Form.Select
                                name="dataObject"
                                label="Data Object"
                                options={dataObjects}
                                placeholder="Select Data Object"
                                error={errors.dataObject}
                                value={state.dataObject}
                                search
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />}

                            <br />

                            <div style={{marginTop: "16px"}}> </div>

                            <div className={classNames(panelBox)}>
                                <Header as="h5" className={marginB4}>Add Data Object Elements (optional)</Header>
                                <div style={{height: "20px"}}> </div>
                                {dataElements && dataElements.length > 0 &&
                                <>
                                    <div className={allElements}>
                                        {dataElements.map((i, index) => {
                                            return <div  className={marginB10} key={index}>
                                                <Checkbox
                                                    checked = {i.checked}
                                                    label={i.text}
                                                    value={i.value}
                                                    onClick={addElement} />
                                            </div>
                                        })}
                                    </div>
                                </>}
                            </div>

                            <br />

                            <div style={{marginTop: "16px"}}> </div>

                            <div className={classNames(panelBox, marginB30)}>
                                <Header as="h5" className={marginB4}>Add Boundary (optional)</Header>
                                <Search
                                    className={"searchNoResults"}
                                    name="searchObjects"
                                    placeholder="Search Data Objects"
                                    onSearchChange={handleInputSearch}
                                    value={value}
                                />
                                {state.selectedDataBoundaries && state.selectedDataBoundaries.length > 0 &&
                                <>
                                    <div className={selectedElements}>
                                        {state.selectedDataBoundaries.map((i, index) => {
                                            return <div  className={marginB10} key={index}>
                                                <Checkbox
                                                    checked = {true}
                                                    label={(i.dataElement ? i.dataElement.name : "") + " - " + (i.sampleValue ? i.sampleValue.name : "")}
                                                    onClick={() => removeDataBoundary(i)} />
                                            </div>
                                        })}
                                    </div>
                                </>}

                                {state.dataBoundariesSearch && state.dataBoundariesSearch.length > 0 &&
                                <>
                                    <Divider horizontal>Boundaries</Divider>
                                    <div className={allElements}>
                                        {state.dataBoundariesSearch.map((b, bi) => {
                                            return <div  className={marginB10} key={bi}>
                                                <Checkbox
                                                    checked = {false}
                                                    label={(b.dataElement ? b.dataElement.name : "") + " - " + (b.sampleValue ? b.sampleValue.name : "")}
                                                    onClick={() => addDataBoundary(b)} />
                                            </div>
                                        })}
                                    </div>
                                </>}
                                {(!state.dataBoundariesSearch) && state.dataBoundaries && state.dataBoundaries.length > 0 &&
                                <>
                                    <Divider horizontal>Boundaries</Divider>
                                    <div className={allElements}>
                                        {state.dataBoundaries.map((i, index) => {
                                            return <div  className={marginB10} key={index}>
                                                <Checkbox
                                                    checked = {false}
                                                    label={(i.dataElement ? i.dataElement.name : "") + " - " + (i.sampleValue ? i.sampleValue.name : "")}
                                                    onClick={() => addDataBoundary(i)} />
                                            </div>
                                        })}
                                    </div>
                                </>}
                            </div>

                        </Form.Field>

                    </Form.Group>

                </Dialog.Content>

                <Dialog.Actions>
                    <Button type="submit" primary>
                        Submit
                    </Button>
                    <Button onClick={_onClose}>
                        Close
                    </Button>
                </Dialog.Actions>

            </Form>
        </Dialog>
    )

}


export default AddDataContent